import gql from 'graphql-tag';

/**
 * 微信登录
 */
export const fetchLoginExternalDocument = gql`
  mutation loginExternal($args: ExternalLoginMutationArgs) {
    loginExternal(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 验证码登录
 */
export const fetchPhoneLoginDocument = gql`
  mutation phoneLogin($args: PhoneLoginArgs!) {
    phoneLogin(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 获取微信手机号
 */
export const fetchWechatPhoneDocument = gql`
  mutation getWechatPhone($args: GainPhone!) {
    getWechatPhone(args: $args) {
      token
      openIdKey
    }
  }
`;

/**
 * 发送验证码
 */
export const fetchSendCodeDocument = gql`
  mutation sendCode($phone: String!) {
    sendCode(phone: $phone) {
      code
      message
    }
  }
`;
